module.exports = __webpack_public_path__ + "static/media/DSCF1792-3.f5d0b293.jpg";